import React from "react";
import { IEmployeeGroupAbsences } from '../../domain/employeeGroups/IEmployeeGroupAbsences';
import { BaseComponent } from "../core/BaseComponent";
import { AbsenceDayRow } from "./AbsenceDayEmployee";

interface AbsenceDayTableProps {
    date: Date;
    group: IEmployeeGroupAbsences;
    smallRows: boolean;
    onLoading: (isLoading: boolean, isCurrentlyInMeeting: boolean) => void;
}
interface AbsenceDayTableState {

}

export class AbsenceDayTable extends BaseComponent<AbsenceDayTableProps, AbsenceDayTableState> {

    render() {
        const items: JSX.Element[] = [];
        const group = this.props.group;
        if (group.employees) {
            const employees = group.employees;
            employees.forEach(a => items.push(<AbsenceDayRow key={a.name} calendar={a} smallRow={this.props.smallRows} date={this.props.date} />));
        }
        return (
            <div key={this.props.group.id}>
                {items}
            </div>
        )
    }
}
